import { render, staticRenderFns } from "./ImportBills.vue?vue&type=template&id=88820e5a&scoped=true"
import script from "./ImportBills.vue?vue&type=script&lang=js"
export * from "./ImportBills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88820e5a",
  null
  
)

export default component.exports